import React from 'react'
import { Link } from 'react-router-dom'
import moment from 'moment'
import _ from 'lodash'
import {
  Dropdown, Icon, Menu, message, Button, Select as AntdSelect, Modal, Row, Col,
} from 'antd'
import {
  Select, SmallText, Div, Button as KonsysButton, Icon as KSIcon, H4,
} from 'konsys-ui'
import { theme } from '../../styles/_variables'
import { P } from '../../pages/job-page/styled'
import history from '../../history'
import PERMISSION from '../../constants/permissions'
import COMPANY_NAME from '../../constants/company-name'
import { mappingValueToText } from '../../pages/job-page/detail/component-renderer'

const { color } = theme

export const CellText = props => (
  <P font='sarabun' padding='3px' {...props}>{props.children}</P>
)

export const HeaderLabel = props => (
  <SmallText bold color={color.coolGrey} font='sarabun' style={{ fontWeight: 700 }}>{props.children}</SmallText>
)

export const InputWithPlaceHolder = ({ handleChange }) => (
  <input placeholder='ค้นหา' onChange={e => handleChange(e.target.value)}/>
)

export const ActionSelectorBackup = ({ disabled }) => (
  <Select
    disabled={disabled}
    dropdown
    data={[
      { value: 'edit', text: 'แก้ไข' },
      { value: 'achrive', text: 'ลบ' },
    ]}
    buttonProps={{
      text: 'แก้ไข',
      ghost: true,
      color: color.primaryColor,
      small: true,
      width: '100px',
    }}
  />
)

const menu = (id, isExpired) => (
  <Div>
    <Menu>
      <Menu.Item key='view' disabled={!_.includes(window.perms, PERMISSION.VIEW_JOB)}>
        <Link target="_blank" to={`/job/view/${id}`}>
          ดูรายละเอียด
        </Link>
      </Menu.Item>
      <Menu.Item key='edit' disabled={!_.includes(window.perms, PERMISSION.UPDATE_JOB)}>
        <Link target="_blank" to={`/job/edit/${id}`}>
          แก้ไข
        </Link>
      </Menu.Item>
      <Menu.Item key='add-shipping-order' disabled={!_.includes(window.perms, PERMISSION.CREATE_SHIPPING_ORDER) || isExpired}>
        <Link target="_blank" to={`/shipping-order/add/${id}`}>
            สร้างใบสั่งบรรทุกใหม่
        </Link>
      </Menu.Item>
      <Menu.Item key='history' disabled={!_.includes(window.perms, PERMISSION.VIEW_JOB)}>
        <Link target="_blank" to={`/job/history/${id}`}>
            ประวัติการแก้ไข
        </Link>
      </Menu.Item>
    </Menu>
  </Div>
)

export const ActionSelector = ({ id, isExpired }) => (
  <Dropdown overlay={menu(id, isExpired)} trigger='click'>
    <Button>
      ดูรายละเอียด <Icon type="down" />
    </Button>
  </Dropdown>
)

const customerMenu = id => (
  <Div>
    <Menu>
      <Menu.Item key='view' disabled={!_.includes(window.perms, PERMISSION.VIEW_JOB)}>
        <Link target="_blank" to={`/job/view/${id}`}>
          ดูรายละเอียด
        </Link>
      </Menu.Item>
    </Menu>
  </Div>
)

export const CustomerActionSelector = ({ id }) => (
  <Dropdown overlay={customerMenu(id)} trigger='click'>
    <Button>
      ดูรายละเอียด <Icon type="down" />
    </Button>
  </Dropdown>
)

export const Wrapper = props => (
  <Div
    display='block'
    width='100%'
    flexDirection='row'
    padding={props.padding || '40px 0'}
    justifyContent={props.center && 'center'}
    alignItems='flex-end'
    style={{ borderBottom: `1px solid ${color.paleGrey}`, overflow: props.overflow && 'auto' }}
  >
    {props.children}
  </Div>
)

export const DropdownSelector = ({
  data, handleChange, typeNameTh, moreProps,
}) => {
  const width = typeNameTh ? '120px' : '100px'
  return (
    <AntdSelect
      defaultValue='ทั้งหมด'
      dropdown
      maxHeight='none'
      style={{ width }}
      onChange={e => (e === 'ALL' ? handleChange('') : handleChange(e))}
      {...moreProps}
    >
    {
      data.map(v => <AntdSelect.Option key={v.value} value={v.value}>{v.text}</AntdSelect.Option>)
    }
    </AntdSelect>
  )
}

export const ActionBar = ({
  loading, isAddMode, isViewMode, doAction, mutationVariables, props, disabled,
}) => (
  <Div
    position='fixed'
    height='72px'
    bottom='0'
    left='0'
    right='0'
    style={{ background: `${color.primaryColor}33` }}
    display='flex'
    justifyContent='flex-end'
    alignItems='center'
    padding='0 32px 0 0'
  >
    <KonsysButton
      loading={loading}
      disabled={loading || (isViewMode && !_.includes(window.perms, PERMISSION.UPDATE_JOB)) || disabled}
      text={isAddMode ? 'สร้างใหม่' : isViewMode ? 'แก้ไข' : 'บันทึก'}
      icon={isAddMode ? 'fas fa-plus' : isViewMode ? 'fas fa-edit' : 'fas fa-save'}
      inverse
      onClick={() => {
        if (isViewMode) history.push(`/job/edit/${props.match.params.id}`)
        else {
          doAction({
            variables:
              isAddMode
                ? {
                  ...mutationVariables,
                  average: parseFloat(mutationVariables.average),
                }
                : { id: parseInt(props.match.params.id, 10), ...mutationVariables, average: parseFloat(mutationVariables.average) },
          }).then(({ data }) => {
            const resp = isAddMode ? data.CreateJob : data.UpdateJob

            if (resp.success) {
              message.success(resp.message)

              if (isAddMode) history.push('/job')
              // else history.push(`/job/view/${props.match.params.id}`)
            } else message.error(resp.message)
          })
        }
      }}
    />
  </Div>
)

export const DetailModal = ({
  jobDetailData, visible, setVisible,
}) => (
  <Modal
    title={[<P key ='1' bold color={theme.color.cadetBlue}>เลขที่สัญญา: <span style={{ color: theme.color.black }}>{jobDetailData?.JobInfo?.number || '-'}</span></P>]}
    visible={visible}
    destroyOnClose={true}
    onCancel={() => setVisible(false)}
    footer={[<Button key='close' onClick={() => setVisible(false)}>ปิด</Button>]}
  >
    <Div display='flex' flexDirection='column' width='100%' alignItems='center'>
      <Div display='flex' margin='0 0 16px' flexDirection='column' width='100%' alignItems='center' padding='16px' bgColor={theme.color.linkWater} style={{ border: `0.5px solid ${theme.color.mercury}`, borderRadius: '10px' }}>
        <P margin='0 0 8px 0' bold>รายละเอียด</P>
        <Row style={{ margin: '4px 0', width: '100%' }} type='flex' justify='space-between' gutter={16} align='middle'>
          <Col span={12} style={{ padding: '0' }}>
            <SmallText color={theme.color.cadetBlue}>วันที่เริ่มอายุสัญญา</SmallText>
          </Col>
          <Col span={12} style={{ padding: '0' }}>
            <SmallText color={theme.color.coolGray} bold>{moment(jobDetailData?.JobInfo?.contractStart).format('DD/MM/YYYY') || '-'}</SmallText>
          </Col>
        </Row>
        <Row style={{ margin: '4px 0', width: '100%' }} type='flex' justify='space-between' gutter={16} align='middle'>
          <Col span={12} style={{ padding: '0' }}>
            <SmallText color={theme.color.cadetBlue}>วันที่หมดอายุสัญญา</SmallText>
          </Col>
          <Col span={12} style={{ padding: '0' }}>
            <SmallText color={theme.color.coolGray} bold>{moment(jobDetailData?.JobInfo?.contractEnd).format('DD/MM/YYYY') || '-'}</SmallText>
          </Col>
        </Row>
        <Row style={{ margin: '4px 0', width: '100%' }} type='flex' justify='space-between' gutter={16} align='middle'>
          <Col span={12} style={{ padding: '0' }}>
            <SmallText color={theme.color.cadetBlue}>ประเภทสินค้า</SmallText>
          </Col>
          <Col span={12} style={{ padding: '0' }}>
            <SmallText color={theme.color.coolGray} bold>{jobDetailData?.JobInfo?.cargo || '-'}</SmallText>
          </Col>
        </Row>
      </Div>
      <Div display='flex' margin='0 0 16px' flexDirection='column' width='100%' alignItems='center' padding='16px' bgColor={theme.color.linkWater} style={{ border: `0.5px solid ${theme.color.mercury}`, borderRadius: '10px' }}>
        <P margin='0 0 8px 0' bold>การจ้างงาน</P>
        <Row style={{ margin: '4px 0', width: '100%' }} type='flex' justify='space-between' gutter={16} align='middle'>
          <Col span={8} style={{ padding: '0' }}>
            <SmallText color={theme.color.cadetBlue}>ผู้ว่าจ้าง</SmallText>
          </Col>
          <Col span={16} style={{ padding: '0' }}>
            <SmallText color={theme.color.coolGray} bold>{jobDetailData?.JobInfo?.Customer?.companyName || '-'}</SmallText>
          </Col>
        </Row>
        <Row style={{ margin: '4px 0', width: '100%' }} type='flex' justify='space-between' gutter={16} align='middle'>
          <Col span={8} style={{ padding: '0' }}>
            <SmallText color={theme.color.cadetBlue}>ผู้ขนส่ง</SmallText>
          </Col>
          <Col span={16} style={{ padding: '0' }}>
            <SmallText color={theme.color.coolGray} bold>{COMPANY_NAME[jobDetailData?.JobInfo?.companyType]}</SmallText>
          </Col>
        </Row>
        <Row style={{ margin: '4px 0', width: '100%' }} type='flex' justify='space-between' gutter={16} align='middle'>
          <Col span={8} style={{ padding: '0' }}>
            <SmallText color={theme.color.info}>ต้นทาง</SmallText>
          </Col>
          <Col span={16} style={{ padding: '0' }}>
            <SmallText color={theme.color.coolGray} bold>{jobDetailData?.JobInfo?.startDestinationLocation?.name || '-'}</SmallText>
          </Col>
        </Row>
        <Row style={{ margin: '4px 0', width: '100%' }} type='flex' justify='space-between' gutter={16} align='middle'>
          <Col span={8} style={{ padding: '0' }}>
            <SmallText color={theme.color.info}>ปลายทาง</SmallText>
          </Col>
          <Col span={16} style={{ padding: '0' }}>
            <SmallText color={theme.color.coolGray} bold>{jobDetailData?.JobInfo?.endDestinationLocation?.name || '-'}</SmallText>
          </Col>
        </Row>
      </Div>
      <Div display='flex' flexDirection='column' width='100%' alignItems='center' padding='16px' bgColor={theme.color.linkWater} style={{ border: `0.5px solid ${theme.color.mercury}`, borderRadius: '10px' }}>
        <Div width='100%' display='flex' justifyContent='space-between'>
          <P margin='0 0 8px 0' bold>สถานะการขนส่ง</P>
          <P color={theme.color.coolGray} style={{ textAlign: 'end' }}>หน่วย: {jobDetailData?.JobInfo?.dealType === 'PERWEIGHT' ? mappingValueToText(jobDetailData?.JobInfo?.unit) : 'เที่ยว'}</P>
        </Div>
        <Row style={{ margin: '4px 0', width: '100%' }} type='flex' justify='space-between' gutter={16} align='middle'>
          <Col span={12} style={{ padding: '0' }}>
            <SmallText color={theme.color.cadetBlue}>น้ำหนัก/เที่ยวทั้งหมด</SmallText>
          </Col>
          <Col span={12} style={{ padding: '0', textAlign: 'end' }}>
            <SmallText color={theme.color.coolGray} bold>{jobDetailData?.JobInfo?.contractWeight || '-'}</SmallText>
          </Col>
        </Row>
        <Row style={{ margin: '4px 0', width: '100%' }} type='flex' justify='space-between' gutter={16} align='middle'>
          <Col span={12} style={{ padding: '0' }}>
            <SmallText color={theme.color.cadetBlue}>น้ำหนัก/เที่ยวที่ขนส่งแล้ว</SmallText>
          </Col>
          <Col span={12} style={{ padding: '0', textAlign: 'end' }}>
            <SmallText color={jobDetailData?.JobInfo?.deliveredWeight > jobDetailData?.JobInfo?.contractWeight ? theme.color.success : theme.color.error} bold>{jobDetailData?.JobInfo?.deliveredWeight || '-'}</SmallText>
          </Col>
        </Row>
      </Div>
    </Div>
  </Modal>
)
